import https from "./axios";
import qs from "qs";
//
export const InvitationRegist = form => {
  return https().post("/v2/users/", form);
};
// 
export const invitationWithdraw = () => {
  return https().post("/v2/lucky/withdrawal/");
};

// 
export const invitationDraw = form => {
  return https().get("/v2/lucky/attend/", { params: form });
};
//
export const postInvitationDraw = form => {
  return https().post("/v2/lucky/attend/", form);
};
// 1&2
export const exchangePrize = form => {
  return https().post("/v2/marketing-oct/exchange-prize/", form);
};
//
export const shareInfo = form => {
  return https().post("/v2/marketing/pss-app/mgm_facade", form);
};
//
export const inviteUsers = () => {
  return https().get("/v2/users/invited-users/");
};
// 
export const getDigisignLink = form => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).get(
    "/idn-app-server/api/v2/digisign/getDigisignLink?" + qs.stringify(form)
  );
};
// 11 - 
export const queryColumnValue = form => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).post("/idn-app-server/api/v2/marketing/queryColumnValue", form);
};
// 11 - 
export const addColumnValue = form => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).post("/idn-app-server/api/v2/marketing/addColumnValue", form);
};

// 11 - 
export const reportRequest = form => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).post("/idn-event-tracking/event/h5/report", form);
};